import {
  Avatar,
  AvatarFallbackText,
  AvatarImage,
} from "@/components/ui/avatar";
import { HStack } from "@/components/ui/hstack";
import { Link as ExpoLink } from "expo-router";
import Logo from "./logo/logo";
import { VStack } from "@/components/ui/vstack";
import { useUserControllerMe } from "@/generated/api/api";
import { getName } from "@/utils/name";
import { ColorSchemeName } from "react-native";
import { useColorScheme } from "@/components/useColorScheme";

export function WebHeader() {
  const { data: user } = useUserControllerMe();
  const colorScheme: ColorSchemeName = useColorScheme();

  return (
    <VStack className="w-full h-full bg-background-0 border-b border-background-300">
      <HStack className="items-center justify-between w-full h-full max-w-screen-xl self-center pt-4 pl-10 pr-10 pb-3">
        <HStack className="items-center">
          <ExpoLink href="/wallet" replace>
            <Logo
              width="140"
              height="60"
              color={colorScheme === "dark" ? "white" : "black"}
              fill={colorScheme === "dark" ? "white" : "black"}
            />
          </ExpoLink>
        </HStack>

        <ExpoLink href="/(tabs)/profile" replace>
          <Avatar size="md">
            <AvatarFallbackText>{getName(user)}</AvatarFallbackText>
            <AvatarImage source={{ uri: user?.avatarImage ?? undefined }} />
          </Avatar>
        </ExpoLink>
      </HStack>
    </VStack>
  );
}
